import BaseApiService from './api.base.service'

class ImagesApiService extends BaseApiService {
  constructor() {
    super('images')
  }

  getAll() {
    return this.callGet('')
  }

  getAllOdata(params) {
    return this.callGet('/odata', params)
  }

  insert(imageDto) {
    return this.callPost('', imageDto, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  edit(imageId, imageDto) {
    return this.callPatch(`${imageId}`, imageDto, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  delete(imageId) {
    return this.callDelete(`${imageId}`)
  }

  upload(images) {
    return this.callPost('/upload', images, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  getImageTypes() {
    return this.callGet('/ImageTypes')
  }

  getImagesByContentId(id) {
    return this.callGet(`${id}`)
  }
}

export const imagesApi = new ImagesApiService()
